import "@gravity-ui/uikit/styles/fonts.css";
import "@gravity-ui/uikit/styles/styles.css";
import "../node_modules/@gravity-ui/uikit/build/esm/components/Table/Table.css";
import { useAction } from "@reatom/npm-react";
import { useEffect } from "react";
import "react-loading-skeleton/dist/skeleton.css";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "swiper/css";
import "tippy.js/dist/tippy.css";
import "./color.scss";

import { AuthRoutes, PublicRoutes } from "./routes";
import { setUtmParamsAction } from "./store/fetchers/setUtmParamsAction";
import { setVisitorAction } from "./store/fetchers/setVisitorAction";

export const AppRouter = createBrowserRouter([...PublicRoutes, ...AuthRoutes]);

export default function App() {
  const setVisitor = useAction(setVisitorAction);
  const setUtmParams = useAction(setUtmParamsAction);

  useEffect(() => {
    setVisitor();
    setUtmParams();
  }, [setVisitor, setUtmParams]);

  return <RouterProvider router={AppRouter} />;
}
